import { useMutation } from "@tanstack/react-query";
import CurrencyService from "../services";
import { Currency } from "../settingsType/Currency";

const useCreateCurrency = () => {
  return useMutation({
    mutationFn: (newCurrency: Currency) => CurrencyService.create(newCurrency),
    onError: (error) => {
      console.error("Error creating setting:", error);
    },
  });
};

export default useCreateCurrency;
